import { initializeApp } from "firebase/app";
import "firebase/firestore"

const app = initializeApp(JSON.parse(process.env.FIREBASE_CONFIG));

const firestore = app.firestore();

export { firestore };
